var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListingsprem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14723_236588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7794 16.4376L26.3785 6.2742C26.0215 6.00353 25.5289 6.00217 25.1704 6.27088L22.9583 7.92955L20.7553 6.25875C20.3984 5.98807 19.9057 5.98672 19.5473 6.25543L17.3903 7.87269L15.2422 6.2436C14.8853 5.97292 14.3926 5.97156 14.0342 6.24027L0.577594 16.3299C0.325865 16.5188 0.177307 16.815 0.176442 17.1297L0.129581 34.1793C0.128059 34.7333 0.575931 35.1836 1.12993 35.1851L6.64302 35.2003L12.2659 35.2158L27.9876 35.259L33.5007 35.2741L39.1236 35.2896C39.6776 35.2911 40.1279 34.8432 40.1294 34.2892L40.1763 17.2397C40.1772 16.925 40.0302 16.6279 39.7794 16.4376ZM38.126 33.2806L34.5093 33.2707L34.5534 17.2242C34.5543 16.9094 34.4074 16.6125 34.1565 16.4222L24.621 9.19045L25.7688 8.32978L38.1687 17.7341L38.126 33.2806ZM28.9962 33.2555L29.0403 17.209C29.0412 16.8942 28.8943 16.5973 28.6435 16.407L19.053 9.13373L20.1458 8.31447L32.5458 17.7188L32.5031 33.2653L28.9962 33.2556L28.9962 33.2555ZM16.207 33.2202L13.2745 33.2122L12.9214 33.2112L12.9414 25.9372L16.227 25.9462L16.207 33.2202ZM18.2132 33.2257L18.236 24.9486C18.2375 24.3946 17.7896 23.9443 17.2356 23.9428L11.9438 23.9282C11.3898 23.9267 10.9395 24.3746 10.9379 24.9286L10.9152 33.2057L7.65165 33.1967L2.13856 33.1815L2.18129 17.6351L14.6327 8.29903L27.0328 17.7034L26.99 33.2498L18.2132 33.2257Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14723_236588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.222656 0.591797) rotate(0.157475)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingsprem);
export default __webpack_public_path__ + "static/media/listingsprem.d7322c1b116149fabec54d86af8832ec.svg";
export { ForwardRef as ReactComponent };